// import React, { useEffect } from "react";

// const Modal = ({ isOpen, onClose, title, content }) => {
//   // Handle escape key to close the modal
//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.key === "Escape") {
//         onClose();
//       }
//     };
//     document.addEventListener("keydown", handleKeyDown);
//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [onClose]);

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white max-w-[80%] max-h-[90%] overflow-scroll min-w-[400px] p-6 rounded-lg shadow-lg relative">
//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           className="absolute top-3 right-3 text-2xl text-red-600 hover:text-red-800 focus:outline-none"
//         >
//           &times;
//         </button>
//         {/* Modal Content */}
//         <h2 className="text-xl font-semibold text-gray-800 mb-4">{title}</h2>
//         <div className="text-gray-600">{content}</div>
//       </div>
//     </div>
//   );
// };

// export default Modal;


import React, { useEffect } from "react";

const Modal = ({ isOpen, onClose, title, content }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white max-w-[80%] max-h-[90%] min-w-[400px] rounded-lg shadow-lg flex flex-col overflow-hidden">
        
        {/* 🔹 Fixed Header */}
        <div className="sticky top-0 bg-white z-10 px-3 py-2 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="text-2xl text-red-600 hover:text-red-800 focus:outline-none"
          >
            &times;
          </button>
        </div>

        {/* 🔹 Scrollable Content */}
        <div className="px-6 py-4 overflow-y-auto">
          <div className="text-gray-600">{content}</div>
        </div>

      </div>
    </div>
  );
};

export default Modal;